import { render, staticRenderFns } from "./BoxProject.vue?vue&type=template&id=6c5b18be&"
import script from "./BoxProject.vue?vue&type=script&lang=js&"
export * from "./BoxProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports